import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "react-circular-progressbar/dist/styles.css";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import { scrapSubTabList, tabList } from "./../../constant/myPageTab";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import Pagination from "./../../components/molecules/pagination";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import ScrapApi from "../../api/scrap.api";
import { errorHandler } from "../../util/errorHandler";
import Empty from "../../components/molecules/empty";
import moment from "moment";
import { fileUrl } from "../../api/api";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import Loading from "../../components/templates/loading";
import { toast } from "react-toastify";

const MyPageScrapColumn = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [scrapList, setScrapList] = useState([]);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 6, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[3].title);

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    scrapSubTabList[1].title,
  );

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          route.my_page_scrap_column,
        )}`,
        { replace: true },
      );
      return;
    }

    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [isLoading, setIsLoading] = useState(true);

  const dataListFunc = async () => {
    if (sessionStorage.getItem("isLogin") !== "true") return;

    try {
      setIsLoading(true);
      const data = {
        page: page,
        size: pagination.size,
      };

      const response = (await ScrapApi.getColumnScrapList(data)).data.data;

      setScrapList(
        (response?.content ?? []).filter((item) => item?.columnPost),
      );
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.max(1, Math.ceil(response.totalCount / prev.size)),
      }));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 3 ? true : false}
                    title={tab.title}
                  />

                  {index === 3 && (
                    <SubTabWrapper>
                      {scrapSubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 1 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentHeaderWrapper>
                  <LSRgDisplay02 style={{ color: "#000" }}>
                    스크랩한 칼럼
                  </LSRgDisplay02>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 강의 리스트 */}
                <ContentBodyWrapper>
                  {isLoading ? (
                    <Loading />
                  ) : scrapList.length > 0 ? (
                    scrapList.map((item, index) => (
                      <div
                        key={item.id}
                        style={{
                          borderRadius: 15,
                          overflow: "hidden",
                        }}
                      >
                        <ColumnWrapper
                          style={{
                            backgroundImage: item.columnPost
                              ?.thumbnailServerFileNameColumn
                              ? `url(${fileUrl}/${item.columnPost.thumbnailServerFileNameColumn})`
                              : "none",
                          }}
                          onClick={() => {
                            navigate(
                              `${route.column_detail}/${item.columnPost?.id}`,
                            );
                          }}
                        >
                          {/* <ColumnBookmarkWrapper>
                          <ColumnBookmarkIcon
                            src="/assets/icons/bookmark_a.png"
                            alt="북마크"
                          />
                          <LSRgH1HeadLine
                            style={{
                              color: "#fff",
                              marginTop: 8,
                            }}
                          >
                            NN
                          </LSRgH1HeadLine>
                        </ColumnBookmarkWrapper> */}

                          <ProductTitle>{item.columnPost?.title}</ProductTitle>

                          <LSRgH1HeadLine style={{ color: "#fff" }}>
                            {moment(item.columnPost?.createdAt).format(
                              "YYYY.MM.DD",
                            )}
                          </LSRgH1HeadLine>
                        </ColumnWrapper>
                      </div>
                    ))
                  ) : (
                    <Empty title={"스크랩한 칼럼이 없습니다."} />
                  )}
                </ContentBodyWrapper>

                {scrapList.length > 0 &&
                  pagination.totalCount > pagination.size && (
                    <Pagination
                      route={route.my_page_scrap_column}
                      queryString={``}
                      currentPage={Number(page) || 1}
                      totalPages={pagination.totalPages}
                      rangeSize={pagination.rangeSize}
                    />
                  )}
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={tabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={scrapSubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <LSRgH1HeadLine style={{ marginBottom: 20 }}>
              스크랩한 칼럼
            </LSRgH1HeadLine>

            {/* 본문 영역 - 강의 리스트 */}
            <ContentBodyWrapper $isSmall={isSmall}>
              {isLoading ? (
                <Loading />
              ) : scrapList.length > 0 ? (
                scrapList.map((item, index) => (
                  <div
                    key={item.id}
                    style={{
                      borderRadius: 15,
                      overflow: "hidden",
                    }}
                  >
                    <ColumnWrapper
                      style={{
                        backgroundImage: item.columnPost
                          ?.thumbnailServerFileNameColumn
                          ? `url(${fileUrl}/${item.columnPost.thumbnailServerFileNameColumn})`
                          : "none",
                      }}
                      $isSmall={isSmall}
                      onClick={() => {
                        navigate(
                          `${route.column_detail}/${item.columnPost?.id}`,
                        );
                      }}
                    >
                      {/* <ColumnBookmarkWrapper $isSmall={isSmall}>
                      <ColumnBookmarkIcon
                        $isSmall={isSmall}
                        src="/assets/icons/bookmark_a.png"
                        alt="북마크"
                      />
                      <LSRgCaption01
                        style={{
                          color: "#fff",
                          marginTop: 4,
                        }}
                      >
                        NN
                      </LSRgCaption01>
                    </ColumnBookmarkWrapper> */}

                      <ProductTitleMobile>
                        {item.columnPost?.title}
                      </ProductTitleMobile>

                      <LSRgCaption02 style={{ color: "#fff" }}>
                        {moment(item.columnPost?.createdAt).format(
                          "YYYY.MM.DD",
                        )}
                      </LSRgCaption02>
                    </ColumnWrapper>
                  </div>
                ))
              ) : (
                <Empty title={"스크랩한 칼럼이 없습니다."} />
              )}
            </ContentBodyWrapper>

            {scrapList.length > 0 &&
              pagination.totalCount > pagination.size && (
                <Pagination
                  route={route.my_page_scrap_column}
                  queryString={``}
                  currentPage={Number(page) || 1}
                  totalPages={pagination.totalPages}
                  rangeSize={pagination.rangeSize}
                />
              )}
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPageScrapColumn;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: ${(props) => (props.$isSmall ? "stretch" : "center")};
  justify-content: space-between;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "16px" : "0px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const ContentBodyWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  display: flex;
  flex-wrap: wrap;
  column-gap: ${(props) => (props.$isSmall ? "19px" : "29px")};
  row-gap: ${(props) => (props.$isSmall ? "20px" : "30px")};
`;

const ColumnWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  border-radius: 15px;
  padding: ${(props) => (props.$isSmall ? "20px 11.5px" : "40px")};
  width: ${(props) => (props.$isSmall ? "158px" : "480px")};
  height: ${(props) => (props.$isSmall ? "201px" : "610px")};

  &:hover {
    transform: scale(1.04); /* 확대 효과 */
    transition: transform 0.3s ease-in-out; /* 부드러운 애니메이션 */
  }
`;

const ProductTitle = styled(LSBdDisplay02)`
  color: #fff;
  margin-bottom: 18px;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
`;

const ProductTitleMobile = styled(LSBdH1HeadLine)`
  color: #fff;
  margin-bottom: 8px;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 2; // 원하는 라인수
  -webkit-box-orient: vertical;
`;
